/**
 * This is the reducer for the Device Structure component.
 * @param {Object} state - The state object of the Device Structure component.
 * @param {Function} action - The action function to be dispatched
 * @returns {Object} state - The new state of the Device Structure component.
 */
export const deviceStructureReducer = (state, action) => {
	switch (action.type) {
		case "SET_DEVICES_DATA":
			return { ...state, deviceData: action.payload }
		case "SET_SEARCH_STRING":
			return { ...state, searchString: action.payload }
		case "SET_SEARCH_RESULT":
			return { ...state, searchResult: action.payload }
		case "SET_IS_LOADING":
			return {
				...state,
				isLoading: action.payload
			}
		case "SET_IS_ERROR":
			return {
				...state,
				isError: action.payload,
				isLoading: false,
				isSuccess: false
			}
		case "SET_ERROR_MESSAGE":
			return {
				...state,
				errorMessage: action.payload
			}
		case "SET_IS_SUCCESS":
			return {
				...state,
				isSuccess: action.payload,
				isError: false,
				errorMessage: ""
			}
		default:
			return state
	}
}
